<template>
  <b-card no-body class="mb-2">
    <b-card-header>
      <b-row align-v="center">
        <b-col cols="auto" class="mr-auto">
          <h5 class="">Расходы</h5>
        </b-col>
        <b-col cols="auto">
          <b-button size="sm" variant="success" @click.stop="onAddCost()" :disabled="isDisabled">
            <font-awesome-icon icon="plus" class="mr-1"/>
            Добавить
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>
    <b-card no-body class="mx-0">
      <b-table
        id="worker-costs"
        ref="worker-costs"
        class="mb-0"
        striped
        small
        thead-class="top-fixed-thead thead-light"
        table-class="text-small"
        responsive
        show-empty
        :empty-text="$t('message.common.emptyTable')"
        :busy="isBusy"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-compare="sortPeriodCompare"
        no-provider-filtering
        no-provider-paging
        no-provider-sorting
      >
        <template #table-busy>
          <div class="text-center text-success my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Загрузка</strong>
          </div>
        </template>

        <template #cell(worker_cost_type_id)="row">
          <worker-cost-type-select
            id="worker-cost-type-select"
            ref="worker_cost_type_select"
            :is-disabled = "isDisabled"
            v-on:onSelect="onSelectWorkerCostType($event, row)"
            v-bind:id = row.item.worker_cost_type_id
          />
        </template>

        <template #cell(period)="row">
          <div style="display: flex;align-items: center;justify-content: left;">
            <b-form-input
              id="input_start_date"
              size="sm"
              class="widthDate"
              :disabled="isDisabled"
              type="date"
              v-model.date="row.item.start_date"/>
            <div class="mx-1">-</div>
            <b-form-input
              id="input_end_date"
              size="sm"
              class="widthDate"
              :disabled="isDisabled"
              type="date"
              v-model.date="row.item.end_date"/>
          </div>
        </template>

        <template #cell(sum)="row">
          <b-form-input
            id="input_sum"
            size="sm"
            class="widthPrice"
            :disabled="isDisabled"
            autocomplete="off"
            v-model.number="row.item.sum">
          </b-form-input>
        </template>

        <template #cell(comment)="row">
          <b-form-input
            id="input_comment"
            size="sm"
            :disabled="isDisabled"
            autocomplete="off"
            v-model="row.item.comment">
          </b-form-input>
        </template>

        <template #cell(action)="row">
          <b-button size="sm" variant="danger" @click="onRemoveCost(row)" :disabled="isDisabled">
            <font-awesome-icon icon="trash" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <b-card-footer footer-bg-variant="light">
      <b-row align-h="between" align-v="center">
        <b-col cols="auto" class="mr-auto">
          Всего записей: <b>{{items.length}}</b>
        </b-col>
        <b-col cols="auto">
          <b-pagination
            id="worker-costs-pagination"
            pills
            :total-rows="items.length"
            :per-page="perPage"
            v-model="currentPage"/>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>

<script>
import workers from "../../network/workers";
  import dateFormatter from "../../utilites/dateFormatter";
  import helpers from "../../utilites/helpers";
    import WorkerCostTypeSelect from "../Catalogs/WorkerCostTypes/WorkerCostTypeSelect";

export default {
  name: "WorkerCosts",
  components: { WorkerCostTypeSelect },
  mixins: [
    workers,
    dateFormatter, helpers
  ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      workerId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'worker_cost_type_id',
          label: 'Тип расхода',
          class: 'widthCostType',
          sortable: false,
        },
        {
          key: 'period',
          label: 'Период',
          class: 'widthPrice',
          sortable: true,
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
          sortable: false,
        },
        {
          key: 'comment',
          label: 'Комментарий',
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      sortBy: 'period',
      sortDesc: true,
    }
  },
  methods: {
    configure(workerId) {
      this.workerId = workerId;
      this.getCosts();
    },
    async getCosts() {
      this.isBusy = true;
      const result = await this.getWorkerCostsById(this.workerId);
      this.isBusy = false;

      if (result.data == null) { return; }

      let costs = result.data.items;
      costs.forEach(function (cost) {
        cost.start_date = this.formatDate(this.getDateFromServerString(cost.start_date));
        cost.end_date = this.formatDate(this.getDateFromServerString(cost.end_date));
      }.bind(this));

      this.items = costs;
    },
    onAddCost() {
      const cost = {
        worker_id: 0,
        worker_cost_type_id: 0,
        worker_cost_type_name: 0,
        start_date: this.formatDate(new Date()),
        end_date: this.formatDate(new Date()),
        sum: null,
        comment: ''
      };
      this.items.unshift(cost);
      this.setTableOrder();
    },
    onRemoveCost(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление расходов исполнителя";
      const message = `${this.$t("Вы уверены, что хотите удалить расход:")} ${this.deleteRow.worker_cost_type_name}?`;
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      }.bind(this));
    },
    async saveCosts(workerId) {
      let costs = this.items;

      costs.forEach(function (cost) {
        cost.start_date = this.getDateToServer(cost.start_date).toISOString();
        cost.end_date = this.getDateToServer(cost.end_date).toISOString();
      }.bind(this));

      return await this.postWorkerCosts(costs, workerId);
    },
    onSelectWorkerCostType(costType, row) {
      if (costType != null) {
        row.item.worker_cost_type_id = costType.id;
        row.item.worker_cost_type_name = costType.name;
      } else {
        row.item.worker_cost_type_id = 0;
        row.item.worker_cost_type_name = '';
      }
    },
    setTableOrder() {
      this.sortBy = 'period';
      this.sortDesc = true;
      this.currentPage = 1;
    },
  }
}
</script>

<style>
.widthPrice {
  width: 120px;
}

.widthCatalog {
  width: 200px;
}

.widthPeriod {
  width: 270px;
}

.widthDate {
  width: 130px;
}

.widthCostType {
  min-width: 200px;
}

#worker-costs td {
  text-align: center;
}

#worker-costs th {
  text-align: center;
  vertical-align: middle;
}

#worker-costs-pagination {
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkerCosts.vue